<template>
    <div class="card text-center py-4">
        <div>
            <div class="row">
                <div class="col-12">
                    <div class="p-4">
                        <h4 class="text-primary">{{ $t(`Looks like you didn't connect any social network.`) }}</h4>
                        <p class="mb-4 sub-heading">{{ $t('Please connect them to see full potential of our platform.') }} </p>

                        <div class="row">
                            <div class="col-12 col-lg-4 offset-lg-4">
                                <button @click="$router.push('/instagram')" class="btn btn-social btn-block btn-primary mt-3 btn-instagram">
                                    <i class="bx bxl-instagram-alt button-icon"></i>
                                    {{ $t(`Instagram`) }}
                                </button>
                                <button @click="$router.push('/facebook')" class="btn btn-social btn-block btn-primary mt-3 btn-facebook">
                                    <i class="bx bxl-facebook-square button-icon"></i>
                                    {{ $t(`Facebook`) }}
                                </button>
                                <button @click="$router.push('/youtube')" class="btn btn-social btn-block btn-primary mt-3 btn-youtube">
                                    <i class="bx bxl-youtube button-icon"></i>
                                    {{ $t(`Youtube`) }}
                                </button>
                                <button @click="$router.push('/blog')" class="btn btn-social btn-block btn-warning mt-3">
                                    <i class="fas fa-blog button-icon"></i>
                                    {{ $t(`Google Analytics`) }}
                                </button>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
    export default {
        name: "overviewConnectCard"
    }
</script>

<style scoped>
    .btn-social {
        max-width:350px;
        margin: auto;
    }
    .sub-heading {
        font-size: 1.1em;
    }
</style>
